<template>
    <div class="container-fluid position-relative bg-BAT">
        <loading v-if="loading !== 0"></loading>
        <div>
            <div class="container watch-container py-4">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt="" />
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread" :href="'/get-pdv-details/' + pdv.id">Staff</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" :href="'/get-pdv-details/' + pdv.id"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>

            <div class="container mt-3">
                <div class="row align-items-start">
                    <div class="col-12 col-md-6">
                        <div class="header-portfolio d-flex flex-column">
                            <h5 class="text-title-bat mb-2">Vincular usuario</h5>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 d-block d-md-flex justify-content-md-end">
                        <div v-if="isValidated" class="content-message d-flex align-items-start"
                            style="border-left: 4px solid #FFBA01; background: #FFF0D3; padding: 15px; border-radius: 5px;">
                            <img src="/img-version2/icons/staff/info-circle-staff.svg" alt="icono-info"
                                style="width: 24px; height: 24px; margin-right: 10px;">
                            <p class="mb-0 text-bat" style="color: #333333; font-size: 14px; line-height: 1.5;">
                                {{ validationMessage }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="content-update">
                    <div class="form-cart mt-4">
                        <div>
                            <!-- Paso 1: Input de identificación -->
                            <div v-if="currentStep === 1">
                                <form class="row g-3" @submit.prevent="submitForm">
                                    <!-- Número de identificación -->
                                    <div class="col-12 col-md-6">
                                        <div class="mb-3">
                                            <label for="identification">Número de identificación</label>
                                            <input type="text" id="identification" v-model="identification" class="form-control" placeholder="Ingresa la cédula del usuario a vincular" autocomplete="off" :class="{'border-red': !identification}" style="border-width: 1.5px;" @input="validateNumberInput"/>
                                        </div>
                                    </div>

                                    <!-- Botón de validación -->
                                    <div class="d-flex justify-content-start boton">
                                        <button class="mx-1 btn btnBlue text-title-bat rounded-3 cursor-pointer btn-created-staff" :disabled="!identification" :class="{'btnBlue': identification, 'btn-secondary': !identification}" type="button" @click="validateIdentification">
                                           Solicitar vinculación
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <!-- Paso 2: Formulario completo -->
                            <div v-if="currentStep === 2">
                                <form class="row g-3">
                                    <!-- Tipo de identificación -->
                                    <div class="col-12 col-md-6">
                                        <div>
                                            <label for="idType" class="form-label">Tipo de identificación</label>
                                            <select id="idType" v-model="idType" class="form-control" style="border-width: 1.5px;" @blur="validateTypeDocument" :disabled="!isEditable" :style="{'border-width': '1.5px', 'border-color': typeIdentificationError ? 'red' : ''}">
                                                <option v-for="option in idTypes" :key="option" :value="option">{{ option }}</option>
                                            </select>
                                            <span v-if="typeIdentificationError" style="color: red;">Por favor ingresa un tipo de documento válido.</span>
                                        </div>
                                    </div>

                                    <!-- Número de identificación -->
                                    <div class="col-12 col-md-6">
                                        <div>
                                            <label for="identification" class="form-label">Número de identificación</label>
                                            <input type="text" id="identification" v-model="identification" style="border-width: 1.5px;" class="form-control" disabled />
                                        </div>
                                    </div>

                                    <!-- Nombre -->
                                    <div class="col-12 col-md-6">
                                        <div>
                                            <label for="name" class="form-label">Nombre</label>
                                            <input type="text" id="name" v-model="name" class="form-control" :style="{'border-width': '1.5px', 'border-color': nameError ? 'red' : ''}"
                                                autocomplete="off" :disabled="!isEditable" @blur="validateName" @input="restrictInput"/>
                                            <span v-if="nameError" style="color: red;">El nombre es obligatorio y debe contener solo letras.</span>
                                        </div>
                                    </div>

                                    <!-- Celular -->
                                    <div class="col-12 col-md-6">
                                        <div>
                                            <label for="mobileNumber" class="form-label">Celular</label>

                                            <input v-if="isEditable" :style="{'border-width': '1.5px', 'border-color': mobileNumberError ? 'red' : ''}" type="text" id="mobile_number" style="border-width: 1.5px;" v-model="mobile_number" class="form-control" autocomplete="off" @blur="validateMobileNumber" @input="restrictMobileInput"/>

                                            <input v-else type="text" :value="formattedPhoneNumber" class="form-control" style="border-width: 1.5px;" autocomplete="off" :disabled="!isEditable"/>

                                            <span v-if="mobileNumberError" style="color: red;">El celular debe ser un número válido de 10 dígitos y debe comenzar con el número 3.</span>

                                        </div>
                                    </div>

                                    <!-- E-mail -->
                                    <div class="col-12">
                                        <div>
                                            <label for="email" class="form-label">E-mail</label>

                                            <input v-if="isEditable" type="email" id="email" v-model="email" style="border-width: 1.5px;" :style="{'border-width': '1.5px', 'border-color': emailError ? 'red' : ''}"
                                                class="form-control" autocomplete="off" @blur="validateEmail" @input="clearEmailError"/>

                                            <input v-else type="email" id="email" :value="formatEmail" style="border-width: 1.5px;"
                                                class="form-control" autocomplete="off" :disabled="!isEditable" />

                                            <span v-if="emailError" style="color: red;">Por favor ingresa un correo electrónico válido.</span>
                                        </div>
                                    </div>

                                    <div class="d-block d-md-flex justify-content-start boton mt-4">
                                        <button v-if="isEditable" :disabled="modalActivateUser" @click="mobileNumberError === false ? validateInputs() : ''" class="w-50 mx-1 btn btnBlue text-title-bat rounded-3" type="button">
                                            Solicitar vinculación
                                        </button>

                                        <button v-else-if="validationMessage === 'Este usuario ya se encuentra registrado en Conecta2'"
                                                :disabled="modalActivateUser" class="mx-1 btn btnBlue text-title-bat rounded-3 btn-created-staff" @click="modalActivateUser = true" type="button" >
                                            Agregar a mi staff
                                        </button>

                                        <button v-else-if="validationMessage === 'El usuario ya se encuentra asociado a tu punto de venta'" class="mx-1 btn btnBlue text-title-bat rounded-3 btn-created-staff"
                                            type="button">
                                            <a :href="`/get-client-pdv-details/${pdv.id}/${clientId}`" class="text-decoration-none text-white text-title-bat cursor-pointer">
                                                Ver detalles del usuario
                                            </a>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="modalActivateUser" :width="getWidth()"
            style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
            :close-on-click-modal="true" :close-on-press-escape="false" :show-close="true">
            <div class="modals pb-0">
                <img src="/img-version2/icons/staff/dangerstaff.svg" alt="Icono">
                <h6 class="mx-auto" style="width: auto!important; max-width: 268px!important;">¿Estás seguro que deseas
                    vincular este usuario?</h6>
            </div>
            <div class="d-flex align-items-center flex-column justify-content-center px-0">
                <div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="buttonTwoStaff" type="buttoYes" @click="handleActivateUser">Si, continuar</div>
                    </div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="text-more cursor-pointer buttonOne" type="buttoNot" @click="modalActivateUser = false">Cancelar</div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="modalExitActivateUser" :width="getWidth()"
            style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;" class="dialog-mobile"
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <div class="modals modal-staff">
                <img src="/img-version2/icons/staff/info-circle.svg" alt="Icono">
                <h6 class="mx-auto text-title-bat" style="width: auto!important; max-width: 268px!important;">Tu solicitud de vinculación ha sido enviada.</h6>
                <p class="text-bat px-0">Si tu solicitud es aprobada, tu usuario se activará próximamente.</p>
            </div>
            <div class="d-flex align-items-center flex-column justify-content-center px-0">
                <div>
                    <div class="col-12" style="padding: 10px 0!important;">
                        <div class="buttonTwo" type="buttoYes" @click="handleExitActivateUser">Aceptar</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    props:{
        client_id:{
            default: null
        },
        pdv: {
            default: null
        },
        client: {
            default: null
        }
    },
    data() {
        return {
            loading: 0,
            currentStep: 1,
            idType: '',
            idTypes: [],
            identification: "",
            name: "",
            email: "",
            mobile_number: "",
            isDisabled: false,
            validationMessage: '',
            isValidated: false,
            isEditable: true,
            clientId: null,
            modalActivateUser: false,
            modalExitActivateUser: false,
            getWidth() {
                if (this.$mq === 'sm') {
                    return '95%';
                } else if (this.$mq === 'md') {
                    return '35%';
                } else if (this.$mq === 'lg') {
                    return '30%';
                } else {
                    return '20%';
                }
            },
            nameError: false,
            emailError: false,
            mobileNumberError: false,
            typeIdentificationError: false,

        };
    },
    computed: {
        formattedPhoneNumber() {
            if (this.mobile_number && this.mobile_number.length >= 5) {
                return this.mobile_number.substring(0, 3) + "****" + this.mobile_number.substring(this.mobile_number.length - 2);
            }
            return this.mobile_number;
        },
        formatEmail() {
            if (this.email && this.email.indexOf('@') !== -1) {
                const [username, domain] = this.email.split('@');
                const visibleUsername = username.substring(0, 3);
                const asterisks = "*".repeat(username.length - 3);
                return visibleUsername + asterisks + "@" + domain;
            }
            return this.email;
        }
    },

    mounted() {

    },

    methods: {

        validateIdentification() {
            if (!this.identification) {
                this.validationMessage = 'El número de identificación es obligatorio.';
                return;
            }
            this.loading = 1;
            this.isValidated = false;
            this.isEditable = true;

            this.validationMessage = '';

            axios.get('/validate-client-exist', {
                params: {
                    identification_number: this.identification,
                    pdv_id: this.pdv.id
                }
            })
            .then(response => {
                this.loading = 0;
                this.isValidated = true;

                if (response.status === 401) {
                    this.isValidated = true;
                    this.validationMessage = response.data.message;
                    this.currentStep = 1;
                    return;
                }

                if (response.status === 200) {
                    this.currentStep = 2;
                    const { message, client, identification_types } = response.data;

                    if (message === 'Este usuario ya se encuentra registrado en Conecta2' && client.id === this.client_id) {
                        this.validationMessage = "Ya perteneces a este punto de venta.";
                        this.currentStep = 1;
                        return;
                    }

                    this.validationMessage = message;
                    this.idTypes = identification_types ? identification_types.map(type => type.identification_type_name) : [];

                    switch (message) {
                        case 'Completa los datos para crear el usuario':
                            this.isEditable = true;
                            break;

                        case 'El usuario ya se encuentra asociado a tu punto de venta':
                            this.isEditable = false;
                            this.clientId = client.id;
                            this.name = client.user.name;
                            this.email = client.user.email;
                            this.mobile_number = client.mobile_number.trim();
                            const identificationType = identification_types.find(type => type.id === client.identification_type_id);
                            this.idType = identificationType ? identificationType.identification_type_name : '';
                            break;

                        case 'Este usuario ya se encuentra registrado en Conecta2':
                            this.isEditable = false;
                            this.name = client.user.name;
                            this.email = client.user.email;
                            this.mobile_number = client.mobile_number.trim();
                            this.clientId = client.id;
                            if (client.identification_type_id && Array.isArray(identification_types) && identification_types.length > 0) {
                                const identificationType = identification_types.find(type => type.id === client.identification_type_id);
                                this.idType = identificationType ? identificationType.identification_type_name : '';
                            } else {
                                this.idType = '';
                            }
                            break;

                        default:
                            this.isEditable = false;
                            break;
                    }
                }
            })
            .catch(error => {
                this.loading = 0;
                this.isValidated = true;

                if (error.response && error.response.status === 401 || error.response.status === 400) {
                    this.validationMessage = error.response.data.message;
                    this.currentStep = 1;
                } else {
                    console.error("Error capturado en .catch():", error);
                    this.validationMessage = "Hubo un error en la solicitud.";
                }
            })
            .finally(() => {
                this.loading = 0;
            });
        },

        handleActivateUser() {
            // let clientId = 0;
            console.log(this.client)
            if (this.client && this.client.id) {
                this.clientId = this.client.id
                // clientId = this.client.id;
            }
            console.log(this.clientId)

            this.associateClientToPDV(this.clientId);
            this.modalActivateUser = false;
            this.modalExitActivateUser = true;
        },
        associateClientToPDV(clientId) {
            axios.post(`/new-client-request/${this.pdv.id}`, {
                name: this.name,
                identification_number: this.identification,
                identification_type_id: this.idTypes.indexOf(this.idType) + 1,
                mobile_number: this.mobile_number,
                email: this.email,
                client_id: clientId
            })
            .then(response => {
                if (response.data.status === 'success') {
                    this.validationMessage = response.data.message;
                } else {
                    this.validationMessage = response.data.message;
                }
            })
            .catch(error => {
                this.validationMessage = "Error al asociar el usuario al PDV. Intenta nuevamente.";
            });
        },
        getIdentificationType(client, identification_types) {
            if (client.identification_type_id && Array.isArray(identification_types) && identification_types.length > 0) {
                const identificationType = identification_types.find(type => type.id === client.identification_type_id);
                return identificationType ? identificationType.identification_type_name : '';
            }
            return '';
        },
        handleExitActivateUser() {
            this.modalExitActivateUser = false;

            window.location.href = `/get-pdv-details/${this.pdv.id}`;
        },

        validateNumberInput() {
            this.identification = this.identification.replace(/[^0-9]/g, '');
        },

        validateName() {
            const nameRegex = /^[a-zA-Z\s]+$/;
            if (!this.name || !nameRegex.test(this.name)) {
                this.nameError = true;
            } else {
                this.nameError = false;
            }
        },

        validateTypeDocument(){
            this.typeIdentificationError = this.idType === '';
        },

        restrictInput(event) {
            this.name = this.name.replace(/[^a-zA-Z\s]/g, '');
        },

        validateMobileNumber() {
            const mobileNumberRegex = /^[0-9]{10}$/;
            if (!mobileNumberRegex.test(this.mobile_number) || !this.mobile_number.startsWith('3')) {
                this.mobileNumberError = true;
            } else {
                this.mobileNumberError = false;
            }
        },

        restrictMobileInput(event) {
            this.mobile_number = this.mobile_number.replace(/[^0-9]/g, '');
        },

        validateEmail() {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(this.email)) {
                this.emailError = true;
            } else {
                this.emailError = false;
            }
        },

        clearEmailError() {
            if (this.email && this.emailError) {
                this.emailError = false;
            }
        },

        validateInputs(){
            this.validateEmail();
            this.validateName();
            this.validateMobileNumber();
            this.validateTypeDocument();
            if (!this.emailError && !this.mobileNumberError && !this.nameError && !this.typeIdentificationError){
                this.modalActivateUser = true
            }
        }
    }
}
</script>
